<template>
  <v-container id="integraciones" tag="section">
    <base-v-component heading="Integraciones" />
    <!-- CENTRALIZADO -->
    <base-material-card color="indigo" icon="mdi-bee" inline class="px-5 py-3">
      <v-toolbar flat color="white"> </v-toolbar>

      <v-tabs
        v-model="tab"
        background-color="deep-purple accent-4"
        center-active
        dark
      >
        <v-tab>Hook Pedidos</v-tab>
        <v-tab>Importaciones</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card>
            <v-card-actions>
              <v-btn
                @click="guardar"
                small
                :loading="loadingGuardar"
                :disabled="sinCambios"
                color="primary"
                >Guardar</v-btn
              >
            </v-card-actions>
            <v-card-title>
              Webhook que se lanzarán al insertar un pedido
            </v-card-title>
            <v-card-text>
              <v-col cols="12" sm="10" class="mx-auto">
                <v-card v-for="(h, i) in hookPedidos" :key="i">
                  <v-card-title>
                    <v-text-field
                      outlined
                      label="Url envío hook"
                      v-model="h.url"
                    /> </v-card-title
                  ><v-card-title>
                    <v-text-field
                      outlined
                      label="Token bearer"
                      v-model="h.token"
                    />
                  </v-card-title>

                  <v-card-title>Parámetros Adicionales de envío</v-card-title>
                  <v-list>
                    <v-list-item v-for="(p, j) in h.paramAdicionales" :key="j">
                      <v-list-item-title>{{ p.param }}</v-list-item-title>
                      <v-list-item-action
                        ><v-btn
                          text
                          color="primary"
                          small
                          @click="removeParametro(h, p)"
                          ><v-icon>mdi-delete</v-icon></v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-text-field
                        label="Añadir parámetro"
                        v-model="parametroAdd.param"
                      />
                      <v-list-item-action
                        ><v-btn
                          text
                          color="primary"
                          small
                          @click="addParametro(h)"
                          ><v-icon>mdi-plus</v-icon></v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                  </v-list>

                  <v-card-actions
                    ><v-btn text color="primary" @click="removeHook(h)"
                      ><v-icon>mdi-delete</v-icon> Eliminar Hook</v-btn
                    ></v-card-actions
                  >
                </v-card>
                <v-list-item>
                  <v-list-item-title
                    ><v-text-field
                      label="Añade una url"
                      v-model="hookAdd.url"
                    ></v-text-field
                    ><v-list-item-subtitle
                      >Url envío hook
                    </v-list-item-subtitle></v-list-item-title
                  >
                  <v-list-item-title
                    ><v-text-field
                      label="Token"
                      v-model="hookAdd.token"
                    ></v-text-field
                    ><v-list-item-subtitle
                      >Token Bearer
                    </v-list-item-subtitle></v-list-item-title
                  >

                  <v-list-item-action
                    ><v-btn text color="primary" small @click="addHook"
                      ><v-icon>mdi-plus</v-icon></v-btn
                    ></v-list-item-action
                  >
                </v-list-item>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-title>Importaciones</v-card-title>
            <v-row>
              <v-col cols="12" md="3">
                <v-btn @click="importarDialog = true" color="secondary"
                  >IMPORTAR CLIENTES</v-btn
                >
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-dialog v-model="importarDialog" max-width="500px">
        <v-card>
          <v-card-title>Importar clientes Clicktom</v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-file-input
                v-model="importarFicheroClicktom"
                label="Elija el fichero clientes clicktom"
              />
              <v-btn
                small
                @click="importarAccionClicktom"
                :disabled="!importarFicheroClicktom"
                color="secondary"
                :loading="importarAccionClicktomLoading"
                >IMPORTAR</v-btn
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </base-material-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      importarAccionClicktomLoading: false,
      importarFicheroClicktom: null,
      importarDialog: false,
      tab: 0,

      loadingGuardar: false,
      sinCambios: true,
      hookPedidos: [
        {
          url: "bla",
          token: "",
          paramAdicionales: [
            {
              param: "",
            },
          ],
        },
      ],
      hookAdd: {
        url: "",
        token: "",
      },
      parametroAdd: {
        param: "",
      },
    };
  },
  watch: {
    hookPedidos(v) {},
  },
  methods: {
    addHook() {
      if (this.hookAdd.url.length > 0) {
        this.hookPedidos.push(this.hookAdd);
        this.hookAdd = {
          url: "",
          token: "",
        };
        this.sinCambios = false;
      }
    },
    addParametro(hook) {
      if (this.parametroAdd.param.length > 0) {
        if (hook.paramAdicionales) {
          hook.paramAdicionales.push(this.parametroAdd);
        } else {
          hook.paramAdicionales = [this.parametroAdd];
        }
        this.parametroAdd = {
          param: "",
        };
        this.sinCambios = false;
      }
    },
    removeHook(item) {
      var index = this.hookPedidos.indexOf(item);
      if (index > -1) {
        this.hookPedidos.splice(index, 1);
        this.sinCambios = false;
      }
    },
    removeParametro(h, p) {
      var index = h.paramAdicionales.indexOf(p);
      if (index > -1) {
        h.paramAdicionales.splice(index, 1);
        this.sinCambios = false;
      }
    },
    guardar() {
      this.loadingGuardar = true;
      this.$store
        .dispatch("negocios/guardarHooks", { pedidos: this.hookPedidos })
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Hooks guardados con éxito",
          });
          this.sinCambios = true;
        })
        .catch((error) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los hooks: " + error,
          });
        })
        .finally(() => (this.loadingGuardar = false));
    },
    getHooks() {
      this.loadingGuardar = true;
      this.$store
        .dispatch("negocios/cargarHooks", { pedidos: this.hookPedidos })
        .then((r) => {
          console.log(r);
          this.hookPedidos = r.pedidos
            ? r.pedidos.map((h) => {
                return {
                  ...h,
                  paramAdicionales: h.paramAdicionales
                    ? h.paramAdicionales
                    : [],
                };
              })
            : [];
        })
        .catch((error) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al cargar los hooks: " + error,
          });
        })
        .finally(() => (this.loadingGuardar = false));
    },
    importarAccionClicktom() {
      this.importarAccionClicktomLoading = true;
      this.$store
        .dispatch(
          "clientes/importarExcelClicktom",
          this.importarFicheroClicktom
        )
        .finally(() => {
          this.importarAccionClicktomLoading = false;
        });
    },
  },
  mounted() {
    this.getHooks();
  },
};
</script>

<style>
</style>